import { CanDeactivate } from '@angular/router';
import { Injectable } from '@angular/core';
import { UiService } from '../services/ui.service';

export declare interface CanDeactivateComponent {
    canDeactivate(): boolean;
}

@Injectable({
    providedIn: 'root'
})
export class CanDeactivateGuard implements CanDeactivate<CanDeactivateComponent> {
    canDeactivate(component: CanDeactivateComponent): boolean {
        return component.canDeactivate();
    }
}
